const hideCookieBanner = () => {
  const banner = document.getElementById('cookiebanner');
  
  if (banner) {
    banner.setAttribute('style', 'display: none !important');
  }
}

export const showCookieBanner = () => {
  const banner = document.getElementById('cookiebanner');
  
  if (banner) {
    banner.setAttribute('style', 'display: block !important');
  }
}
  
export const acceptEssentialCookies = () => {
  if (window.Cookiebot?.submitCustomConsent && !window.Cookiebot?.consented) {
    window.Cookiebot.submitCustomConsent(true, false, false);
    hideCookieBanner();
  }
}

const TIMEOUT = 5000;
const INTERVAL = 300;

export const pollCookiebotBanner = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const check = () => {
      if (document.getElementById("cookiebanner")) {
        resolve();
      } else if (Date.now() - start > TIMEOUT) {
        reject(new Error("Cookiebot banner did not appear in time."));
      } else {
        setTimeout(check, INTERVAL);
      }
    };

    check();
  });
};
